import Model from '@/models/Model'

export default class PosSalePaymentType extends Model {
    resource() {
        return 'pos_sale_payment_type'
    }
}